import { Component, Inject, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Utility } from '../../../common/utility';
import { AppMessages } from '../../../shared/constants/messages';
import { AppConstants } from '../../../shared/constants/constants';
import { ManageOrganizationModel } from '../../../models/organization/organization.model';
import { CompanyAccountService } from './company-account.service';
import { DialogService } from '../../../shared/services/dialog.service';
import { ModifyCompanyAccountPopupComponent } from './modify-company-account-popup.component';
import { CountryModel } from '../../../models/master-data/countries.model';
import { MdDialogRef } from '@angular/material';
import { TMBDataTableComponent } from '../../../components/data-table/data-table.component';
import { SharedService } from '../../../shared/services/share.services';

@Component({
    selector: 'manage-company-accounts',
    templateUrl: 'manage-company-accounts-list.component.html',
    providers: [CompanyAccountService]
})

export class ManageCompanyAccountsComponent extends TMBDataTableComponent implements OnInit {
    manageCompanyAccount: FormGroup;
    filterData = {
        countryId: 'null',
        orgName: '',
        showAll: false
    };
    dataRow = new Array<ManageOrganizationModel>();
    selectedcountry = localStorage.getItem('countryId');
    countries = new Array<CountryModel>();

    constructor(
        private router: Router,
        public dialogService: DialogService,
        public sharedService: SharedService,
        public utility: Utility,
        private companyAccountService: CompanyAccountService) {
            super(sharedService);
        }

    ngOnInit() {
        // Get Country
        this.getcountry();
        this.setPage({ offset: 0 });
    }

    getcountry() {
        this.companyAccountService.getCountryList().subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    this.countries = data;
                    for (let index = 0; index < data.length; index++) {
                        let element = data[index];
                        if (element.countryId === localStorage.getItem('countryId')) {
                            this.filterData.countryId = localStorage.getItem('countryId');
                            this.setPage({ offset: 0 });
                        }
                    }
                }
            }
        );
    }

    setPage(pageInfo) {
        this.page.pageNumber = pageInfo.offset;
        const param = {
            pageSize: this.page.size,
            currentPage: this.page.pageNumber + 1,
            selectedCountry: this.filterData.countryId === 'null' ? '' : this.filterData.countryId,
            keyWord: this.filterData.orgName,
            isShowAll: this.filterData.showAll
        };
        // call api
        this.companyAccountService.getCompanyAccountList(param).subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    this.dataRow = data['list'];
                    for (let element of this.dataRow) {
                        if (element.active.toString() === 'true') {
                            element.active = 'Active';
                        } else {
                            element.active = 'Inactive';
                        }
                    }
                    this.page.pageNumber = pageInfo.offset;
                    this.page.totalElements = data['totalRecords'];
                }
            },
            error => {
            }
        );
    }

    getDataArray(dataArr: any[]) {
        let data = '';
        const seperate = ', ';
        for (let i = 0; i < dataArr.length; i++) {
            data += ((i != 0) ? seperate : '') + dataArr[i];
        }
        return data;
    }

    onSelectedCountry() {
        this.setPage({ offset: 0 });
    }

    onFilter() {
        this.setPage({ offset: 0 });
    }

    onShowAllChange() {
        this.setPage({ offset: 0 });
    }

    onEditItem(id) {
        this.dialogService.openComponentDialog(ModifyCompanyAccountPopupComponent,
            { id: id },
            { width: '900px' }).subscribe(
            (result) => {
                if (result) {
                  this.getcountry();
                  this.reloadPage(this.page.pageNumber, this.dataRow);
                }
            }
            );
    }

    addNewOrg(): void {
        this.dialogService.openComponentDialog(ModifyCompanyAccountPopupComponent,
            {},
            { width: '900px' }).subscribe(
            (result) => {
                if (result) {
                  this.getcountry();
                  this.reloadPage(this.page.pageNumber, this.dataRow);
                }
            });
    }


}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/centre/manage-company-accounts/manage-company-accounts-list.component.ts